import React from 'react';

const Cart = ({ cart, onUpdateQuantity, onRemove, onPurchase, userBalance }) => {
  const totalCost = cart.reduce((sum, item) => sum + (item.price * item.quantity), 0);
  const canAfford = userBalance >= totalCost;

  return (
    <div className="cart">
      <div className="cart-header">
        <h3>🛒 Your Cart</h3>
        <span>{cart.length} item{cart.length !== 1 ? 's' : ''}</span>
      </div>

      <div className="cart-items">
        {cart.map(item => (
          <CartItem
            key={item.id}
            item={item}
            onUpdateQuantity={onUpdateQuantity}
            onRemove={onRemove}
          />
        ))}
      </div>

      <div className="cart-total">
        <h4>Total:</h4>
        <div className="total-amount">${totalCost.toFixed(2)}</div>
      </div>

      <button
        className={`purchase-btn ${!canAfford ? 'insufficient-balance' : ''}`}
        onClick={onPurchase}
        disabled={cart.length === 0}
      >
        {!canAfford 
          ? `💳 Insufficient Balance (Need $${(totalCost - userBalance).toFixed(2)} more)`
          : '🚀 Purchase Now'
        }
      </button>
    </div>
  );
};

const CartItem = ({ item, onUpdateQuantity, onRemove }) => {
  const increaseQuantity = () => {
    if (item.quantity < item.stock) {
      onUpdateQuantity(item.id, item.quantity + 1);
    }
  };

  const decreaseQuantity = () => {
    if (item.quantity > 1) {
      onUpdateQuantity(item.id, item.quantity - 1);
    }
  };

  return (
    <div className="cart-item">
      <img
        src={item.image_url}
        alt={item.name}
        className="cart-item-image"
        onError={(e) => {
          e.target.src = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIHZpZXdCb3g9IjAgMCA1MCA1MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjUwIiBoZWlnaHQ9IjUwIiBmaWxsPSIjRjBGMEYwIi8+CjxwYXRoIGQ9Ik0xNSAyMEgzNVYzMEgxNVYyMFoiIGZpbGw9IiNEMEQwRDAiLz4KPC9zdmc+';
        }}
      />
      
      <div className="cart-item-info">
        <h5 className="cart-item-name">{item.name}</h5>
        <div className="cart-item-price">
          ${item.price.toFixed(2)} × {item.quantity} = ${(item.price * item.quantity).toFixed(2)}
        </div>
      </div>

      <div className="cart-item-controls">
        <button
          className="quantity-btn"
          onClick={decreaseQuantity}
          disabled={item.quantity <= 1}
        >
          −
        </button>
        
        <span className="quantity-display">{item.quantity}</span>
        
        <button
          className="quantity-btn"
          onClick={increaseQuantity}
          disabled={item.quantity >= item.stock}
        >
          +
        </button>
        
        <button
          className="remove-btn"
          onClick={() => onRemove(item.id)}
          title="Remove from cart"
        >
          🗑️
        </button>
      </div>
    </div>
  );
};

export default Cart;